export default __webpack_public_path__ + "static/media/gold-edit-icon.7b43fe09.svg";